import React from 'react';
import { Stack, TextField, FormControl, InputLabel, Select, MenuItem, Typography } from '@mui/material';
import type { ExecuteCheckpointDef } from '@/types/run-stage.types';

interface UnitsValue {
  amount?: number | null;
  unit?: string;
}

interface CheckpointUnitsProps {
  checkpoint: ExecuteCheckpointDef;
  value: unknown;
  onChange: (value: UnitsValue) => void;
  error?: string;
  isReadOnly?: boolean;
}

export const CheckpointUnits: React.FC<CheckpointUnitsProps> = ({
  checkpoint,
  value,
  onChange,
  error,
  isReadOnly,
}) => {
  const current = (typeof value === 'object' && value !== null ? value : {}) as UnitsValue;
  const units = checkpoint.units ?? [];

  return (
    <Stack spacing={0.5}>
      <Typography variant="body2" sx={{ fontWeight: 400 }}>
        {checkpoint.checkpointName}
        {checkpoint.required && <Typography component="span" color="error"> *</Typography>}
      </Typography>
      <Stack direction="row" spacing={1}>
        <TextField
          size="small"
          type="number"
          label="Value"
          value={current.amount != null ? String(current.amount) : ''}
          onChange={(e) =>
            onChange({ ...current, amount: e.target.value === '' ? null : Number(e.target.value) })
          }
          disabled={isReadOnly}
          sx={{ flex: 1 }}
        />
        <FormControl size="small" sx={{ minWidth: 100 }}>
          <InputLabel>Unit</InputLabel>
          <Select
            value={current.unit ?? ''}
            onChange={(e) => onChange({ ...current, unit: e.target.value })}
            label="Unit"
            disabled={isReadOnly}
          >
            {units.map((u) => (
              <MenuItem key={u} value={u}>{u}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>
      {error && (
        <Typography variant="caption" color="error">{error}</Typography>
      )}
    </Stack>
  );
};
